import { mainApi } from '@shared/api'

export const { getTarget, getMealsForDate } = mainApi
